import type { CardInstance, RunState } from "../types/index.js";
import { lookupCard } from "../../content/cards.js";

/** 成功・納期超過・崩壊のすべてで、PJ限定のカード状態を片付ける。 */
export function finishCaseCards(run: RunState): RunState {
  const permanent = (cards: CardInstance[]) => cards.filter((card) => !card.temporaryForCase && !lookupCard(card.cardId)?.caseOnly);
  return {
    ...run,
    deck: permanent(run.deck), hand: permanent(run.hand),
    discard: permanent([...run.discard, ...(run.caseExcluded ?? [])]),
    inPlay: permanent(run.inPlay), aside: permanent(run.aside),
    caseExcluded: [], actionDrawRemaining: undefined,
  };
}
